import type { DeleteCustomDatasourcesMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { DeleteCustomDatasourcesDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

export const useDeleteCustomDatasources = createMutationHook({
  name: 'deleteCustomDatasources',
  mutationOptions: (trpc, onSuccess) =>
    trpc.frontend.customDatasource.deleteMany.mutationOptions({ onSuccess }),
  // The tRPC procedure takes `ids`; the GraphQL document takes `Ids`.
  mapInput: (variables: { Ids: string[] }) => ({ ids: variables.Ids }),
  invalidate: (trpc) => [
    trpc.frontend.customDatasource.customDatasources.queryKey(),
    trpc.frontend.customDatasource.customDatasourceById.queryKey(),
  ],
  mapResponse: (result: {
    deletedCount: number;
  }): DeleteCustomDatasourcesMutation => ({
    delete_custom_datasource: { affected_rows: result.deletedCount },
  }),
  graphqlDocument: DeleteCustomDatasourcesDocument,
  graphqlVariables: (variables: { Ids: string[] }) => ({ Ids: variables.Ids }),
  evictFields: ['custom_datasource', 'custom_datasource_by_pk'],
});
